import { render, staticRenderFns } from "./TableControlsAddBtn.vue?vue&type=template&id=66c9f866"
import script from "./TableControlsAddBtn.vue?vue&type=script&lang=js"
export * from "./TableControlsAddBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports